'use client';

import React from 'react';
import OrderListItem from './OrdersListItem';
import { css } from '@bts-web/utils-style-engine';
import { useOrdersContext } from './OrdersContext.use-client';
import OrdersListEmptyScreen from './OrdersListEmptyScreen';
import OrdersListSkeleton from '../OrdersListSkeleton';
import {
  InfiniteScroll,
  InfiniteScrollItem,
} from '@bts-web/design-system/component/infinite-scroll';
import { ORDERS_LIST_PAGE_SIZE } from '@bts-web/core-features/config';
import { OrdersListItemType } from '../types';

function OrdersList() {
  const ordersContext = useOrdersContext();

  if (ordersContext.isPending === true) {
    return <OrdersListSkeleton />;
  }

  const orderNodes = ordersContext.orders?.edges?.map((order) => order?.node);

  if (!orderNodes?.length) {
    return <OrdersListEmptyScreen />;
  }

  return (
    <div
      className={css({
        borderTop: 'small',
        paddingBottom: { base: '80px', lg: '0' },
      })}
    >
      <InfiniteScroll
        itemsPerPage={ORDERS_LIST_PAGE_SIZE}
        fetchMore={ordersContext.loadMoreOrders}
        hasMore={Boolean(ordersContext.orders?.pageInfo?.hasNextPage)}
        skeleton={<OrdersListSkeleton />}
        items={orderNodes as InfiniteScrollItem[]}
        renderItemComponent={(orderItem) => (
          <OrderListItem item={orderItem as OrdersListItemType} />
        )}
      />
    </div>
  );
}

export default OrdersList;
